/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Box } from '@mui/material';

import {
  FacebookIcon,
  GoogleAnalyticsIcon,
  GoogleAddsIcon,
  LinkedinIcon,
  MicrosoftIcon,
  TikTokIcon,
  PinterestIcon,
  DV360Icon,
  SearchConsoleIcon,
  ShopifyIcon,
  HubspotIcon,
  AppsFlyerIcon,
  AppleIcon,
  WooCommerceIcon,
} from './';
import { ConnectionTypeName } from '../../domains/connections';
import RedditIcon from './RedditIcon';
import OpenAiAdsIcon from './OpenAiAdsIcon';

interface IConnectionTypeProps {
  name: string | undefined;
  analyticsIconSize?: string;
  advertisementIconSize?: string;
}

// eslint-disable-next-line complexity
const ConnectionTypeIcon = ({
  name,
  analyticsIconSize,
  advertisementIconSize = '1em',
}: IConnectionTypeProps): JSX.Element => {
  switch (name) {
    case ConnectionTypeName.DV360:
      return (
        <DV360Icon
          colored
          width={advertisementIconSize}
          height={advertisementIconSize}
        />
      );
    case ConnectionTypeName.LINKEDIN:
      return (
        <LinkedinIcon
          colored
          width={advertisementIconSize}
          height={advertisementIconSize}
        />
      );
    case ConnectionTypeName.META_ADS:
      return (
        <FacebookIcon
          colored
          width={advertisementIconSize}
          height={advertisementIconSize}
        />
      );
    case ConnectionTypeName.UNIVERSAL_ANALYTICS:
    case ConnectionTypeName.GOOGLE_ANALYTICS_4:
      return (
        <GoogleAnalyticsIcon
          width={analyticsIconSize}
          height={analyticsIconSize}
          colored
        />
      );
    case ConnectionTypeName.MICROSOFT_ADS:
      return (
        <MicrosoftIcon
          colored
          width={advertisementIconSize}
          height={advertisementIconSize}
        />
      );
    case ConnectionTypeName.PINTEREST:
      return (
        <PinterestIcon
          colored
          width={advertisementIconSize}
          height={advertisementIconSize}
        />
      );
    case ConnectionTypeName.SEARCH_CONSOLE:
      return (
        <SearchConsoleIcon
          colored
          width={analyticsIconSize}
          height={analyticsIconSize}
        />
      );
    case ConnectionTypeName.TIK_TOK:
      return (
        <TikTokIcon
          colored
          width={advertisementIconSize}
          height={advertisementIconSize}
        />
      );
    case ConnectionTypeName.APPSFLYER:
      return (
        <AppsFlyerIcon
          width={analyticsIconSize}
          height={analyticsIconSize}
          colored
        />
      );
    case ConnectionTypeName.GOOGLE_ADS:
      return (
        <GoogleAddsIcon
          colored
          width={advertisementIconSize}
          height={advertisementIconSize}
        />
      );
    case ConnectionTypeName.SHOPIFY: {
      return (
        <ShopifyIcon
          width={analyticsIconSize}
          height={analyticsIconSize}
          colored
        />
      );
    }
    case ConnectionTypeName.HUBSPOT:
      return (
        <HubspotIcon
          width={analyticsIconSize}
          height={analyticsIconSize}
          colored
        />
      );
    case ConnectionTypeName.REDDIT_ADS:
      return (
        <RedditIcon
          width={advertisementIconSize}
          height={advertisementIconSize}
          colored
        />
      );
    case ConnectionTypeName.APPLE_ADS:
      return (
        <AppleIcon
          width={advertisementIconSize}
          height={advertisementIconSize}
          colored
        />
      );
    case ConnectionTypeName.OPENAI_ADS:
      return (
        <OpenAiAdsIcon
          width={advertisementIconSize}
          height={advertisementIconSize}
          colored
        />
      );
    case ConnectionTypeName.WOOCOMMERCE:
      return (
        <WooCommerceIcon
          width={advertisementIconSize}
          height={advertisementIconSize}
          colored
          style={{ transform: 'scale(1.2)' }}
        />
      );
    default:
      return <></>;
  }
};

export default ConnectionTypeIcon;
